import { SVG } from '@svgdotjs/svg.js';

export function getPaper() {
  // eslint-disable-next-line new-cap
  return SVG();
}
